import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Section } from './Section';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { CHECKOUT_URL } from '../config/launch';
const included = ['Volume 1 — The Screening System', 'Volume 2 — Spine & Back ★', 'Volume 3 — Lower Body', 'Volume 4 — Upper Body', 'Volume 5 — Special Populations', 'Volume 6 — The Professional Shield'];
const bonusLines = ['Bonus 1 — 90-Second Studio Prep Card™', 'Bonus 2 — Injury Language Decoder™', 'Bonus 3 — Safe Substitution Starter Pack™', 'Bonus 4 — Calm Confidence Script Bank™', 'Bonus 5 — First 7 Days Implementation Map™'];
const badges = ['Save $70', 'One-time payment', 'Lifetime access'];
const anchors = [{
  label: 'An injuries workshop',
  value: '$500–600'
}, {
  label: 'A full certification',
  value: '$3,700–6,000'
}, {
  label: 'One hour with a lawyer',
  value: '$200–400'
}, {
  label: 'This system',
  value: '$27'
}];
export function Pricing() {
  return <Section id="pricing" background="white" labelledBy="pricing-heading" data-id="element-198" data-mp="3vyx8e2sbu4gm">
      <h2 id="pricing-heading" className="text-center font-serif text-3xl font-semibold leading-[1.15] text-ink sm:text-[44px]" data-id="element-199" data-mp="4s49x6ox4jfs">
        Get the complete system today
      </h2>

      <div className="mx-auto mt-12 max-w-[640px] overflow-hidden rounded-2xl border border-sage/15 border-t-4 border-t-sage bg-white shadow-lift" data-id="element-200" data-mp="eqaclqijttlp">
        <div className="p-7 sm:p-10" data-id="element-201" data-mp="3d74i4g4n6xcl">
          <h3 className="font-serif text-3xl font-semibold leading-tight text-ink" data-id="element-202" data-mp="3i790kbp4225g">
            Screen &amp; Adapt™ — Complete Edition
          </h3>
          <p className="mt-3 font-sans text-[15px] leading-[1.6] text-ink-soft" data-id="element-203" data-mp="3n525l1eogq45">
            Everything you need to handle every injury conversation with calm, in-scope confidence
          </p>

          <ul className="mt-8 space-y-3" data-id="element-204" data-mp="2ugdbvnfybn2f">
            {included.map(item => <li key={item} className="flex items-start gap-3" data-id="element-205" data-mp="2zfzpvz3lt7ca">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" strokeWidth={2.25} aria-hidden="true" data-id="element-206" data-mp="2rg3525fx02oi" />
                <span className="font-sans text-[15px] leading-snug text-ink" data-id="element-207" data-mp="316ejwn14zwa6">{item}</span>
              </li>)}
          </ul>

          <ul className="mt-6 space-y-3 rounded-xl bg-sage-soft p-5" data-id="element-208" data-mp="2w8w72lk00www">
            {bonusLines.map(item => <li key={item} className="flex items-start gap-3" data-id="element-209" data-mp="28iin7ibki4de">
                <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" strokeWidth={1.75} aria-hidden="true" data-id="element-210" data-mp="23jpe023bczj1" />
                <span className="font-sans text-[15px] leading-snug text-ink-soft" data-id="element-211" data-mp="2dhd9wvcnod2s">{item}</span>
              </li>)}
          </ul>

          <div className="mt-9 text-center" data-id="element-212" data-mp="3tts89wqrrjio">
            <p className="font-sans text-[14px] text-ink-muted" data-id="element-213" data-mp="3owinwvi8ly1p">
              Total value: <span className="line-through" data-id="element-214" data-mp="3oylbl8vx3f39">$157</span>
            </p>
            <p className="mt-1 font-sans text-[14px] text-ink-muted" data-id="element-215" data-mp="8sq0zoxo8km">
              Regular price: <span className="line-through" data-id="element-216" data-mp="5ai5crj6v8ei">$97</span>
            </p>
            <p className="mt-3 font-serif text-6xl font-semibold leading-none text-ink sm:text-7xl" data-id="element-217" data-mp="3nflbmfkw5qgi">
              $27
              <span className="ml-2 align-middle font-sans text-base font-semibold text-ink-muted" data-id="element-218" data-mp="3rhq2j6jyg8zg">
                USD
              </span>
            </p>

            <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-219" data-mp="j37s4y6jkhco">
              {badges.map(badge => <li key={badge} className="rounded-full bg-sage-soft px-3.5 py-1.5 font-sans text-[12px] font-semibold text-sage" data-id="element-220" data-mp="a8tbosa9z0rz">
                  {badge}
                </li>)}
            </ul>

            <div className="mt-8 flex flex-col items-center" data-id="element-221" data-mp="11yg0lwj75dmc">
              <p className="mb-3 font-sans text-[12px] text-ink-muted" data-id="element-222" data-mp="16rhi8casfr9m">
                Transactions will be charged in local currency.
              </p>
              <CtaButton href={CHECKOUT_URL} size="xl" className="w-full sm:w-auto" data-id="element-223" data-mp="3f55v79lbwk0y">
                Yes, I want Screen &amp; Adapt™
              </CtaButton>
              <TrustRow className="mt-4 justify-center" data-id="element-224" data-mp="35a44wafbhbws" />
            </div>
          </div>
        </div>
      </div>

      <ul className="mx-auto mt-10 grid max-w-4xl grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-225" data-mp="319k8j92kicbp">
        {anchors.map(anchor => <li key={anchor.label} className="rounded-xl bg-paper px-4 py-4 text-center" data-id="element-226" data-mp="1ugirjin411i">
            <p className="font-sans text-[12px] leading-snug text-ink-muted" data-id="element-227" data-mp="3t101rlymqxaw">{anchor.label}</p>
            <p className="mt-1.5 font-sans text-[15px] font-semibold text-ink" data-id="element-228" data-mp="3o63zzu3lcvkl">{anchor.value}</p>
          </li>)}
      </ul>
    </Section>;
}